import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// We cannot go past react-dnd 14 for now since v15 removes support
// for class based components (called Decorator API) https://github.com/react-dnd/react-dnd/releases/tag/v15.0.0

// if there is a need for a higher react-dnd version. Make sure to not mix and match different
// versions on the same page as that will cause breakage

// Wrap HTML5Backend to handle race conditions where drag events
// fire after the drag state has been cleared. This prevents the
// "Cannot call hover while not dragging" error.
// See: https://github.com/react-dnd/react-dnd/issues/1534
function createSafeHTML5Backend(manager) {
  const backend = HTML5Backend(manager);
  const originalSetup = backend.setup;

  backend.setup = function () {
    originalSetup.call(this);

    const originalHandleTopDragOver = this.handleTopDragOver;
    this.handleTopDragOver = (e) => {
      try {
        return originalHandleTopDragOver.call(this, e);
      } catch (err) {
        if (err.message?.includes('Cannot call hover while not dragging')) {
          // Silently ignore - this is a known Safari race condition
          return;
        }
        throw err;
      }
    };
  };

  return backend;
}

export default function withDragDropContext(Component) {
  return function WrappedComponent(props) {
    return (
      <DndProvider backend={createSafeHTML5Backend}>
        <Component {...props} />
      </DndProvider>
    );
  };
}
